import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './SeanceEditScreen';
import SeanceEdit from './SeanceEditScreen';
import { StoreState } from 'src/store/reducers';

import { getSeance, deleteFileSeance, getFiles, createFilesSeance, getSeances } from 'src/store/actions/seance-actions';

import { toast } from 'react-toastify';
import { QueryParams } from '../../../../../../../../../types/grid';
import { getServiceTypes } from '../../../../../../../../../store/actions/service-type-actions';
import { getServiceLocations } from '../../../../../../../../../store/actions/service-location-actions';
import { getFormValues } from 'redux-form';
import { getProgramBooks } from 'src/store/actions/program-book-actions';
import { getProgramBookAnswers } from 'src/store/actions/program-book-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        valuesForm: getFormValues('seance-form')(state),
        pgValuesForm: getFormValues('program-form')(state),
        seance: state.seances.current,
        programBooks: state.programBooks,
        programBookAnswers: state.programBookAnswers,
        seances: state.seances.data,
        inProgress: state.seances.inProgress,
        inProgressAnswers: state.programBookAnswers.inProgress,
        files: state.seances.currentFiles,
        serviceTypes: state.serviceTypes.data,
        serviceLocations: state.serviceLocations.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: async (id) => await dispatch(getSeance(id)),
        getFiles: (id) => dispatch(getFiles(id)),
        getProgramBooks: (params: QueryParams) => dispatch(getProgramBooks(params)),
        getProgramBookAnswers: (params: QueryParams) => dispatch(getProgramBookAnswers(params)),
        getServiceTypes: async (params: QueryParams) => await dispatch(getServiceTypes(params)),
        getServiceLocations: async (params: QueryParams) => await dispatch(getServiceLocations(params)),
        getSessionsData: async (params: QueryParams) => await dispatch(getSeances(params)),
        addFiles: (id, requestType: string, files: any, isDatasheet: boolean) =>
            dispatch(
                createFilesSeance(
                    id,
                    requestType,
                    files,
                    isDatasheet,
                    () => toast.success('File added successfully'),
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
        removeFile: (id) => dispatch(deleteFileSeance(id)),
    };
}

const SeanceEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(SeanceEdit);

export default SeanceEditScreen;
